import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(buildAccountDetails),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(createAccount),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(doInitializeFacebookForm),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(doSubmitFacebookForm),
    _marked5 =
/*#__PURE__*/
regeneratorRuntime.mark(watchFacebookFormSagas);

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as logger from 'universal-logger';
import { defineMessages } from 'react-intl';
import { initialize, SubmissionError } from 'redux-form';
import { createFormAction } from 'redux-form-saga';
import { all, call, fork, put, select, spawn, takeEvery } from 'redux-saga/effects';
import { getUserLocation, gtmSafeRedirect } from 'redux/saga/helpers';
import { friendbuyCode as getFriendbuyCode } from 'redux/saga/selectors/friendbuy';
import { deepAssign, deepExtract } from 'helpers/deep';
import { ga } from 'helpers/multitrack';
import { getForApi as getUtmValues } from 'helpers/utmValues';
import { transformConsentForApi } from 'components/Consent/Consent.saga';
import { authorizeFacebook, createUserAndLogIn, doLoginWithFacebook, getFacebookProfile } from 'features/Login/Authentication.saga';
import { postSignupTracking } from 'features/Signup/Signup.saga';
import { ERROR_SIGNUP_FB_EXISTING_ACCOUNT, ERROR_SIGNUP_FB_MISSING_EMAIL } from 'constants/api-error-codes';
var messages = defineMessages({
  contactSupport: {
    id: 'facebook-signup.contact-support',
    defaultMessage: 'Sorry, we’re unable to create your account at this time. Please, <a target="_blank" rel="noopener noreferrer" href="/contact">reach out to us</a> for account help.',
    hasHtml: true
  },
  disclaimer: {
    id: 'facebook-signup.disclaimer',
    defaultMessage: 'By clicking ‘Sign up with Facebook’ or ‘Continue,’ I agree to the {linkTerms} and {linkPrivacy}.'
  },
  missingEmail: {
    id: 'facebook-signup.missing-email',
    defaultMessage: 'Your Facebook account must have an email to sign up. Please add one or sign up via email.'
  }
});
export var FACEBOOK_FORM = 'signup-card-facebook';
export var facebookFormAction = createFormAction(FACEBOOK_FORM);
export var initializeFacebookForm = function initializeFacebookForm(hiddenFields) {
  return {
    type: "INITIALIZE_".concat(FACEBOOK_FORM),
    hiddenFields: hiddenFields
  };
};
export function buildAccountDetails(client, form) {
  var _ref, _ref2, activeLocation, consents, conversion, friendbuyCode;

  return regeneratorRuntime.wrap(function buildAccountDetails$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return all([call(getUserLocation, client), call(transformConsentForApi, form), call(getUtmValues), select(getFriendbuyCode)]);

        case 2:
          _ref = _context.sent;
          _ref2 = _slicedToArray(_ref, 4);
          activeLocation = _ref2[0];
          consents = _ref2[1];
          conversion = _ref2[2];
          friendbuyCode = _ref2[3];

          // Ensure RAF leads are correctly tracked
          if (friendbuyCode) {
            deepAssign('utm.utm_term', conversion, friendbuyCode);
          }

          return _context.abrupt("return", {
            consents: consents,
            conversion: conversion,
            newsletter_subscribed: true,
            gls_location_id: deepExtract('location.id', activeLocation, null)
          });

        case 10:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
export function buildProduct(form) {
  var productKey = {
    offer: 'msa_offer_id',
    plan: 'plan_id'
  }[form.productType];
  return productKey ? _defineProperty({}, productKey, form.productId) : {};
}
export function createAccount(client, facebookToken, accountDetails, product) {
  var errorCode, message;
  return regeneratorRuntime.wrap(function createAccount$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return call(createUserAndLogIn, client, facebookFormAction, _objectSpread({}, accountDetails, product, {
            facebook: {
              token: facebookToken
            }
          }));

        case 3:
          return _context2.abrupt("return", _context2.sent);

        case 6:
          _context2.prev = 6;
          _context2.t0 = _context2["catch"](0);
          errorCode = deepExtract('code', _context2.t0);

          if (!(errorCode === ERROR_SIGNUP_FB_EXISTING_ACCOUNT)) {
            _context2.next = 17;
            break;
          }

          _context2.next = 12;
          return call(doLoginWithFacebook, client, null, facebookToken);

        case 12:
          _context2.next = 14;
          return call(gtmSafeRedirect, '/');

        case 14:
          return _context2.abrupt("return");

        case 17:
          if (!(errorCode === ERROR_SIGNUP_FB_MISSING_EMAIL)) {
            _context2.next = 21;
            break;
          }

          message = messages.missingEmail.defaultMessage;
          _context2.next = 24;
          break;

        case 21:
          _context2.next = 23;
          return spawn(logger.error, 'Failed to create account with facebook token', _context2.t0);

        case 23:
          message = messages.contactSupport.defaultMessage;

        case 24:
          return _context2.abrupt("return", Promise.reject(message));

        case 25:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[0, 6]]);
}
export function doInitializeFacebookForm(client, _ref4) {
  var hiddenFields;
  return regeneratorRuntime.wrap(function doInitializeFacebookForm$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          hiddenFields = _ref4.hiddenFields;
          _context3.next = 3;
          return put(initialize(FACEBOOK_FORM, _objectSpread({}, hiddenFields, {
            marketing: true,
            marketingDisclaimer: null,
            searchable: true,
            searchableDisclaimer: null,
            terms: messages.disclaimer.defaultMessage
          })));

        case 3:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}
export function doSubmitFacebookForm(client, _ref5) {
  var form, FB, facebookToken, accountDetails, product, userId, profile, _message;

  return regeneratorRuntime.wrap(function doSubmitFacebookForm$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          form = _ref5.payload;
          _context4.prev = 1;
          FB = client && client.FB || window.FB;
          _context4.next = 5;
          return call(authorizeFacebook, client);

        case 5:
          facebookToken = _context4.sent;
          _context4.next = 8;
          return call(buildAccountDetails, client, form);

        case 8:
          accountDetails = _context4.sent;
          _context4.next = 11;
          return call(buildProduct, form);

        case 11:
          product = _context4.sent;
          _context4.next = 14;
          return call(createAccount, client, facebookToken, accountDetails, product);

        case 14:
          userId = _context4.sent;
          _context4.next = 17;
          return call(getFacebookProfile, FB);

        case 17:
          profile = _context4.sent;
          _context4.next = 20;
          return call(postSignupTracking, 'facebook', profile, userId);

        case 20:
          _context4.next = 22;
          return call(ga, 'Membership Purchase', 'Membership Purchase Account Creation');

        case 22:
          _context4.next = 24;
          return put(facebookFormAction.success());

        case 24:
          _context4.next = 33;
          break;

        case 26:
          _context4.prev = 26;
          _context4.t0 = _context4["catch"](1);
          _message = deepExtract('message', _context4.t0);
          _context4.next = 31;
          return call(ga, 'Membership Purchase', 'Membership Purchase Account Creation Error', _message || 'Unknown Error');

        case 31:
          _context4.next = 33;
          return put(facebookFormAction.failure(new SubmissionError({
            _error: _message || messages.contactSupport.defaultMessage
          })));

        case 33:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[1, 26]]);
}
export function watchFacebookFormSagas(client) {
  return regeneratorRuntime.wrap(function watchFacebookFormSagas$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return fork(takeEvery, initializeFacebookForm().type, doInitializeFacebookForm, client);

        case 2:
          _context5.next = 4;
          return fork(takeEvery, facebookFormAction.REQUEST, doSubmitFacebookForm, client);

        case 4:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}